import React, { useEffect, useState } from 'react';

import { ENTITY_INVESTORS_TABLE_COLUMNS } from 'constants/entities';
import { usePaginationWithSearch } from 'hooks/use-pagination-with-search/usePaginationWithSearch';
import { CompanyInvestor } from 'interfaces';
import { getEntityInvestors } from 'modules/current-user/action';
import { selectEntityInvestors, selectIsAdmin } from 'modules/current-user/selectors';
import { useAppDispatch, useAppSelector } from 'modules/store';
import NoCompanyInvestorsAdded from 'page-components/company-investors/NoCompanyInvestorsAdded';
import { Pagination } from 'shared-components';
import Table from 'shared-components/table';

import EntityInvestorsItem from './EntityInvestorsItem';

interface Props {
  companyId?: number;
}

const EntityInvestorsList = ({ companyId }: Props) => {
  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(selectIsAdmin);
  const [isLoading, setIsLoading] = useState(false);
  const { data, ...paginationData } = useAppSelector(selectEntityInvestors);
  const { page, setPage } = usePaginationWithSearch();

  useEffect(() => {
    if (!companyId) return;
    setIsLoading(true);
    dispatch(getEntityInvestors({ id: companyId, isAdmin: isAdmin, page: 1, per_page: 7 }))
      .unwrap()
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch, isAdmin, companyId]);

  return (
    <>
      <Table columns={ENTITY_INVESTORS_TABLE_COLUMNS} className='[&_th]:first:pl-1'>
        {data?.length && !isLoading ? (
          data.map((investor: CompanyInvestor) => <EntityInvestorsItem key={investor.id} investor={investor} />)
        ) : (
          <NoCompanyInvestorsAdded />
        )}
      </Table>
      <Pagination currentPage={page} updatePage={setPage} {...paginationData} />
    </>
  );
};

export default EntityInvestorsList;
